import type { z } from "zod"

import { standardStringSchema } from "./string.schema"

export const minPasswordLength = 12

export const passwordSchema = standardStringSchema.min(minPasswordLength)

interface ValidatePasswordMatchProps {
  confirmPassword: string | undefined
  password: string | undefined
}

export const isPasswordMatch = ({
  confirmPassword,
  password,
}: ValidatePasswordMatchProps) => confirmPassword === password

export const passwordMatchIssue: z.core.$ZodSuperRefineIssue = {
  code: "custom",
  origin: "confirm_password",
  path: ["confirmPassword"],
}
